import { purgeStoredState } from 'redux-persist'
import {
  FETCH_LOCATIONS,
  UPDATE_LOCATION,
  SHOW_LOCATION_DETAILS,
  HIDE_LOCATIONS_DETAILS,
  RECEIVED_LOCATIONS,
  RECEIVED_USERS,
  HANDLE_DATE_CHANGE,
  HANDLE_DETAILS_DATE_CHANGE,
  UPDATE_DATE_FOCUS,
  SELECT_TIMESLOT,
  SHOW_BOOKING_INVITATION_MODAL,
  CLOSE_BOOKING_INVITATION_MODAL,
  RECEIVED_OPTIONS,
  UPDATE_BOOKING,
  SET_INVITEE_EMAIL,
  SHOW_USER,
  RECEIVED_COMPANIES,
  REQUEST_COMPANIES,
  SHOW_INVITATIONS_LIST,
  SHOW_SEARCH,
  SET_USER_IN_SEARCH,
  SET_COMPANY_IN_SEARCH,
  SHOW_SWITCH,
  HIDE_SWITCH,
  SWITCH_COMPANY_CHANGE,
  SWITCH_BUILDING_CHANGE,
  ON_TYPE_SEARCH
} from '../actions/locations'

import moment from 'moment'

const locationsReducer = (
  state = {
    showSwitch: false,
    selectedTypedCompanies: [],
    companies: [],
    users: []
  },
  action
) => {
  console.log(action)
  // persistStore(this.props).purge()

  switch (action.type) {
    case FETCH_LOCATIONS:
      return {
        ...state,
        fetchedLocations: false
      }

    case SHOW_LOCATION_DETAILS:
      return {
        ...state,
        selectedLocation: action.location,
        fetchedLocations: true,
        selectedTimeslot: undefined
      }
    case HIDE_LOCATIONS_DETAILS:
      return {
        ...state,
        selectedTimeslot: undefined,
        selectedLocation: undefined,
        fetchedLocations: true,
        detailsFilterDate: undefined
      }
    case RECEIVED_LOCATIONS:
      return {
        ...state,
        fetchedLocations: true,
        locations: action.locations
      }

    case RECEIVED_USERS:
      return {
        ...state,
        // fetchedUsers: true,
        users: action.users
      }
    case REQUEST_COMPANIES:
      return {
        ...state,
        isFetching: true
      }
    case RECEIVED_COMPANIES:
      return {
        ...state,
        isFetching: false,
        companiesFetched: true,
        companies: action.json
        //   error: null
      }
    case UPDATE_LOCATION:
      return {
        ...state,
        locations: state.locations.map((e) => (e._id === action.location._id ? action.location : e)),
        selectedLocation: action.location
      }
    case HANDLE_DATE_CHANGE:
      return {
        ...state,
        filterDate: moment(action.filterDate),
        detailFocused: false
      }
    case HANDLE_DETAILS_DATE_CHANGE:
      return {
        ...state,
        detailsFilterDate: moment(action.filterDate),
        focused: false,
        selectedTimeslot: undefined
      }

    case UPDATE_DATE_FOCUS:
      return {
        ...state,
        focused: action.focused,
        detailFocused: action.detailFocused
      }
    case SELECT_TIMESLOT:
      return {
        ...state,
        selectedTimeslot: action.timeslot,
        availableInterval: action.availableInterval
      }
    case SHOW_BOOKING_INVITATION_MODAL:
      return {
        ...state,
        showBookingInvitationModal: true
      }
    case CLOSE_BOOKING_INVITATION_MODAL:
      return {
        ...state,
        showBookingInvitationModal: false
      }
    case RECEIVED_OPTIONS:
      return {
        ...state,
        options: action.options
      }
    case UPDATE_BOOKING:
      return {
        ...state,
        selectedLocation: {
          ...state.selectedLocation,
          bookings: state.selectedLocation.bookings.map((b) => (b._id === action.booking._id ? { ...b, invitees: action.booking.invitees } : b))
        }
      }
    case SET_INVITEE_EMAIL:
      return {
        ...state,
        inviteeEmail: action.inviteeEmail
      }

    case SHOW_INVITATIONS_LIST:
      return {
        ...state,
        showCondition: true
      }

    case SHOW_SEARCH:
      return {
        ...state,
        showCondition: false
      }
    case SET_USER_IN_SEARCH:
      return {
        ...state,
        selectedUser: action.selectedUser
      }

    case SET_COMPANY_IN_SEARCH:
      // let newSelectedCompanies = state.selectedTypedCompanies

      // newSelectedCompanies.push(action.selectedCompany)

      return {
        ...state,
        companies: action.companies
      }

    case SHOW_SWITCH:
      return {
        ...state,
        showSwitch: true
      }

    case HIDE_SWITCH:
      return {
        ...state,
        showSwitch: false
      }

    case SWITCH_COMPANY_CHANGE:
      return {
        ...state,
        handleSwitchCompanyChange: false
      }

    case SWITCH_BUILDING_CHANGE:
      return {
        ...state,
        checkedByBuilding: action.checkedByBuilding
      }

    case ON_TYPE_SEARCH:
      return {
        ...state,
        typedText: action.typedText,
        selectedUser: undefined
      }

    default:
      return state
  }
}

export default locationsReducer



// WEBPACK FOOTER //
// ./src/reducers/locations.js